import React, { useState } from "react";
import { useFormik } from "formik";
import { ApiPostNoAuth } from "../../helpers/API/ApiData";
import { Link, Navigate, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { string, ref } from "yup";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const initialValues = {
  password: "",
  confirmpassword: "",
};

function ForgotPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const [isRequested] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Mindestens 8 Zeichen")
      .max(50, "Maximal 50 Zeichen")
      .matches(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, "Passwort muss Groß- und Kleinbuchstaben sowie Zahlen enthalten")
      .required("Passwort ist erforderlich"),

    confirmpassword: string()
      .required("Bitte bestätigen Sie Ihr Passwort")
      .oneOf([ref("password")], "Passwörter stimmen nicht überein"),
  });

  const formik: any = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      const data: any = {
        token: token,
        newPassword: values.password,
      };

      await ApiPostNoAuth("users/change-password", data)
        .then((res: any) => {
          try {
            if (parseInt(res?.data?.status) / 100 === 2) {
              navigate("/auth/login");
              window.location.reload();

              setSubmitting(false);
            } else {
              setSubmitting(false);
              setStatus("Passwort konnte nicht geändert werden.");
              toast.error("Passwort konnte nicht geändert werden");
            }
          } catch {
            setSubmitting(false);
            setStatus("Verbindungsfehler. Bitte versuchen Sie es erneut.");
          }
        })
        .catch((err: any) => {
          toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
        });
    },
  });

  return (
    <>
      <ToastContainer />
      {isRequested && <Navigate to="/auth" replace />}
      {!isRequested && (
        <Box sx={{ maxWidth: 450, width: "100%", mx: "auto" }}>
          <Box sx={{ textAlign: "center", mb: { xs: 5, lg: 10 } }}>
            <Typography variant="h4" component="h3">
              Passwort ändern
            </Typography>
            <Typography color="text.secondary" fontWeight="bold">
              Wählen Sie ein neues Passwort
            </Typography>
          </Box>
          <form onSubmit={formik.handleSubmit}>
            {formik.status && (
              <Alert severity="error" sx={{ mb: 3 }}>
                {formik.status}
              </Alert>
            )}
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                type="password"
                variant="outlined"
                margin="normal"
                name="password"
                placeholder="Neues Passwort"
                {...formik.getFieldProps("password")}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                type="password"
                variant="outlined"
                margin="normal"
                name="confirmpassword"
                placeholder="Passwort bestätigen"
                {...formik.getFieldProps("confirmpassword")}
                error={formik.touched.confirmpassword && Boolean(formik.errors.confirmpassword)}
                helperText={formik.touched.confirmpassword && formik.errors.confirmpassword}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                color="brand"
                size="large"
                type="submit"
                sx={{ my: 1.5, py: 1.5, px: 4 }}
                disabled={formik.isSubmitting}
              >
                Einreichen
              </Button>
              <Link to="/auth" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  color="brand"
                  size="large"
                  sx={{ my: 1.5, py: 1.5, px: 4 }}
                >
                  Abbrechen
                </Button>
              </Link>
            </Box>
          </form>
        </Box>
      )}
    </>
  );
}

export default ForgotPassword;
